

//Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	

import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, Typography, Box, Checkbox, FormGroup, FormControlLabel } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { participantdemographicClear, selectParticipantDemographicsById } from '../../../reducers/admincenter_participantdemographics';
import { adminparticipantDelete, selectAdminParticipantById } from '../../../reducers/admincenter_participants';
import { selectContextEntities } from '../../../reducers/global_contexts';
import MergeIcon from '@mui/icons-material/Merge';
import { selectErrorMessagesByNegativeCode } from '../../../reducers/reference_errormessages';
import { fetchParticipants } from "../../../reducers/admincenter_participants";
import { fetchParticipantMerges, participantmergeClear } from '../../../reducers/admincenter_participantmerge';
import ParticipantTable from './ParticipantTable';



const ParticipantMerge = (props) => {
    const dispatch = useDispatch()

    const ParticipantGuid = props.Participant && props.Participant.ParticipantGuid
    const Participant = useSelector(state => selectAdminParticipantById(state, ParticipantGuid))

    const { user: currentUser } = useSelector((state) => state.auth);

    const Contexts = useSelector(state => selectContextEntities(state))
    const { mergeParticipantGuid } = Contexts


    const ParticipantAdditionalInfo = useSelector(state => selectParticipantDemographicsById(state, Participant && Participant.ParticipantGuid))


    const Participant_From = useSelector(state => selectAdminParticipantById(state, ParticipantAdditionalInfo && ParticipantAdditionalInfo.ParticipantGuid))
    const Participant_To = useSelector(state => selectAdminParticipantById(state, mergeParticipantGuid))


    const participantMergeStatus = useSelector(state => state.participantmerges.status)
    const participantMergeError = useSelector(state => state.participantmerges.error)
    const ErrorMessage = useSelector(state => selectErrorMessagesByNegativeCode(state, participantMergeError && participantMergeError.ErrorID))
    const [isError, setIsError] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)

    const [confirmAction, setConfirmAction] = useState(false)

    useEffect(() => {
        if (participantMergeStatus === "success") {
            setIsSuccess(true)
            dispatch(fetchParticipants({ authToken: currentUser.AuthToken, page:0 }))
            setTimeout(() => {                
                dispatch(participantdemographicClear())
                dispatch(adminparticipantDelete(Participant))
                handleCancel()
            }, 3000)

        }
        else if (participantMergeStatus === "failed") {
            setIsError(true)
        }
    }, [participantMergeStatus])

    useEffect(() => {
        setConfirmAction(false)
    }, [Participant_To])

    const SaveToDatabase = () => {
        dispatch(fetchParticipantMerges({
            ParticipantId_Guid_From: Participant_From.ParticipantGuid
            , ParticipantId_Guid_To: Participant_To.ParticipantGuid
            , authToken: currentUser.AuthToken
        }))

    }

    const handleCancel = () => {
        setIsError(false)
        setIsSuccess(false)
        
        dispatch(participantmergeClear())
        props.cancelButton(1)

    }
    const MainContainer = (incoming) => {
        const incAlign = incoming.align
        return (
            <Box
                borderRight={incAlign === "right" ? 1 : 0}
                borderLeft={incAlign === "left" ? 1 : 0}
                pr={incAlign === "right" ? 2 : 0}
                pl={incAlign === "left" ? 2 : 0}

            >
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={12} md={12}>
                        <Typography variant="body2" align={incAlign}>username: <strong>{incoming.Participant.UserName}</strong></Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant="body2" align={incAlign}>email: <strong>{incoming.Participant.Email}</strong></Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant="body2" align={incAlign}>birthday: <strong>{incoming.Participant.BioDOB}</strong></Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant="body2" align={incAlign}>group name: <strong>{incoming.Participant.GroupName}</strong></Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant="body2" align={incAlign}>last login: <strong>{incoming.Participant.LastLogin}</strong></Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant="body2" align={incAlign}>status: <strong>{incoming.Participant.StatusDisplay}</strong></Typography>
                    </Grid>
                </Grid>
            </Box>

        )
    }
    return (
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h4" align="center" sx={{ pb: 1 }}>Merge Participant</Typography>
            </Grid>


            {
                Participant_From && Participant_From.ParticipantGuid
                && (

                    <Grid item xs={5}>
                        <MainContainer Participant={Participant_From} align="right" />
                    </Grid>
                )
            }
            <Grid item xs={2} >
                <Box display="flex" justifyContent="center">
                    <MergeIcon color="primary" fontSize="100px" sx={{ fontSize: "100px", transform: "rotate(90deg)" }} />
                </Box>
            </Grid>

            {Participant_To && Participant_To.ParticipantGuid
                && (
                    <Grid item xs={5}>

                        <MainContainer Participant={Participant_To} align="left" />
                    </Grid>
                )
            }

            <Grid item xs={12}>
                <ParticipantTable TableLocation="MERGE PARTICIPANT" />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1" align="center" gutterBottom>You're about to merge the SOURCE account into the DESTINATION account.
                    All assessments will be moved to the DESTINATION account and the SOURCE account will be permanently deleted. Click MERGE PARTICIPANT to continue
                </Typography>
                <Box display="flex" justifyContent="center">

                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={confirmAction} onChange={(e) => { setConfirmAction(e.target.checked) }} />} label="I understand" />
                    </FormGroup>
                </Box>

            </Grid>
            <Grid item xs={12} justifyContent="center">
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="success"
                                disabled={

                                    !(
                                        mergeParticipantGuid
                                        && Participant_From
                                        && Participant_To
                                        && Participant_To.ParticipantGuid !== Participant_From.ParticipantGuid
                                        && confirmAction === true
                                    )
                                }
                                onClick={() => { SaveToDatabase() }}>Merge Participant</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="error" onClick={() => { handleCancel() }}>Cancel</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            {

                isError === true && (
                    <Grid item xs={12}>
                        <Box>
                            <Typography variant="h6" color="error" align="center">
                                {
                                    (ErrorMessage && ErrorMessage.length > 0 && ErrorMessage[0].MessageTypeContent)
                                    ||
                                    (participantMergeError && participantMergeError.ErrorMessage)
                                }
                            </Typography>
                        </Box>
                    </Grid>
                )
            }
            {

                isSuccess === true && (
                    <Grid item xs={12}>
                        <Box>
                            <Typography variant="h6" color="success.main" align="center">
                                Merged participants successfully!
                            </Typography>
                        </Box>
                    </Grid>
                )
            }
        </Grid>
    )
}
export default ParticipantMerge